import React, { Suspense, useRef } from 'react';
import NavbarComponent from './Components/Navbar';
import ModalComponent from './Components/Modal';
import LoadingPage from './Pages/Loading';
import { GetLazyPage } from './Utils/GetLazyPage.js';
import { Web3ReactProvider } from '@web3-react/core';
import { Web3Provider } from '@ethersproject/providers';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';

function App() {
	const HomePage = GetLazyPage(import('./Pages/Home'));
	const DashboardPage = GetLazyPage(import('./Pages/Dashboard'));
	const CalculatorPage = GetLazyPage(import('./Pages/Calculator'));

	const AppContainerRef = useRef();

	function getWeb3Library(provider) {
		return new Web3Provider(provider);
	}

	return (
		<Web3ReactProvider getLibrary={getWeb3Library}>
			<BrowserRouter>
				<NavbarComponent AppContainerRef={AppContainerRef} />
				<ModalComponent
					ref={(ModalComponent) => {
						window.ModalComponent = ModalComponent;
					}}
				/>
				<section
					style={{
						paddingRight: '40px',
						paddingLeft: '170px',
						transition: 'all 0.5s ease',
					}}
					ref={AppContainerRef}
				>
					<Suspense fallback={<LoadingPage />}>
						<Routes>
							<Route path="/" element={<HomePage />} exact />
							<Route path="/dashboard" element={<DashboardPage />} exact />
							<Route path="/calculator" element={<CalculatorPage />} exact />
						</Routes>
					</Suspense>
				</section>
			</BrowserRouter>
		</Web3ReactProvider>
	);
}

export default App;
